import { ShowWrapper } from "@/layouts/ShowWrapper";
import { PoolsActions, PoolsDetailTabs } from "@/resources-def/pools-comp";

export const ShowPool = () => {
  return (
    <ShowWrapper
      actions={<PoolsActions />}
      details={PoolsDetailTabs()}
    />
  );
};